<template>
  <v-container :loading="loading">
    <v-row>
      <v-col>
        <v-tabs
          v-model="tab"
          color="primary"
          slider-color="primary"
        >
          <v-tab ripple>
            Übersicht
          </v-tab>
          <v-tab ripple>
            Bestandsliste
          </v-tab>
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <v-row>
                  <DetailOverview :contract="contract" />

                  <PositionOverview :positions="positions" :chart="googleChart" />
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <PurchaseItemList :purchase-items="purchaseItems" :contract="{id: contract.id, number: contract.number}" />
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <v-row />
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Default'
import { formattedDateString } from '@/plugins/formatDate.js'
import DetailOverview from '@/Components/Contract/DetailOverview'
import PositionOverview from '@/Components/Contract/PositionOverview'
import PurchaseItemList from '@/Components/Contract/PurchaseItemList'

export default {
   components: {
      DetailOverview,
      PositionOverview,
      PurchaseItemList
   },
   metaInfo () {
      // don't know your return object structure,
      // maybe you should check whole this.getViewPage
      return {
         title: this.title ? this.title : `Vertrag ${this.contract.number}`,
      }
   },
   layout: (h, page) => h(Layout, [page]),

   props: {
      contract: {
         type: Object,
         required: true,
      },
      positions: {
         type: Array,
         required: true,
      },
      googleChart: {
         type: Object,
         required: true,
      },
      purchaseItems: {
         type: Array,
         required: true
      }
   },
   data () {
      return {
         loading: false,
         tab: 0
      }
   },
   computed: {
      wholePrices () {
         const price = {
            mon: 0.0,
            k: 0.0,
         }
         this.positions
            .filter((pos) => pos.amount !== null)
            .forEach((pos) => {
               if (pos.billing_type === '1m') {
                  price.mon += parseFloat(pos.price)
               } else {
                  price.k += parseFloat(pos.price)
               }
            })
         return price
      },
   },
   methods: {
      getDateString (date) {
         return formattedDateString(date)
      },
   },
}
</script>
